import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface CategoriesListCSSStyle extends CRBTUICSSStyle
{
   
}

export class CategoriesListCSSStyleImpl extends CRBTUICSSStyleImpl implements CategoriesListCSSStyle
{
   getWrapperCSSStyle(): object
   {
        return {
            height: "100%",
            width: "100%"
        };
   }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categorieslist/categorieslistcss.tsx